'use client';

import ExpandArrowIcon from '@upzi/web-shell/icons/expand-arrow-icon';
import dynamic from 'next/dynamic';
import { memo, useState } from 'react';
import { Button } from '@upzi/web-shell/ui/button';
import { cn } from '@/lib/utils';
import type { MobileLocationSheetProps } from './mobile-location-sheet';
import {
  MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME,
  MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
} from './mobile-job-filter-trigger-styles';

const MobileLocationSheet = dynamic(
  () =>
    import('./mobile-location-sheet').then(
      module => module.MobileLocationSheet
    ),
  {
    ssr: false,
    loading: () => (
      <Button
        type="button"
        variant="outline"
        disabled
        className={MOBILE_JOB_FILTER_TRIGGER_CLASSNAME}
      >
        <ExpandArrowIcon size={16} aria-hidden />
        Đang tải…
      </Button>
    ),
  }
);

export const LazyMobileLocationSheet = memo(function LazyMobileLocationSheet(
  props: MobileLocationSheetProps
) {
  const [isActivated, setIsActivated] = useState(false);

  if (isActivated) {
    return <MobileLocationSheet {...props} defaultOpen />;
  }

  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => setIsActivated(true)}
      className={cn(
        MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
        'max-w-[220px] justify-start',
        props.value.length > 0 && MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME
      )}
    >
      <span>
        Địa điểm{props.value.length > 0 ? ` (${props.value.length})` : ''}
      </span>
      <ExpandArrowIcon size={16} aria-hidden />
    </Button>
  );
});
